import React, { Fragment, useEffect, useState } from "react";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Translator from "Languages/Utility/Translator";
import PageTitle from "Components/PageTitle/PageTitle";
import ProfileInfo from "./components/ProfileInfo";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import ProfilePassword from "./components/ProfilePassword";
import UserProfileService from "Services/http/endpoints/userProfile/UserProfileService";
import {
  CircularProgress,
  FormControlLabel,
  Grid,
  Icon,
  Switch,
  useTheme,
} from "@material-ui/core";
import showNotify from "Helpers/Notify";
import ProfileEmail from "./components/ProfileEmail";
import ProfilePhone from "./components/ProfilePhone";
import { useTranslation } from "react-i18next";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Box, Tab } from "@material-ui/core";
import * as Icons from "react-bootstrap-icons";

export default function Profile() {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const [data, setData] = useState(null);
  const [twoFactor, setTwoFactor] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState("last_Name");

  const handleChange = (event, newTab) => {
    setTab(newTab);
  };

  const switchChange = async (e) => {
    setTwoFactor(e.target.checked);
    try {
      setLoading(true);
      const data = {
        Key: read("userKey"),
        UserName: read("userId"),
        TwoFactor: e.target.checked,
      };
      const response = await UserProfileService.putChangeAcounts(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        setTwoFactor(e.target.checked);
        if (e.target.checked) {
          showNotify({
            text: t("successfully_activated"),
            customClass: "success",
          });
        } else {
          showNotify({
            text: t("successfully_disabled"),
            customClass: "success",
          });
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = { Key: read("userKey"), UserName: read("userId") };
        const response = await UserProfileService.getProfileInfo(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          setData(response.data.Value);
          setTwoFactor(response.data.Value.TwoFactor);
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <div
        className={`page-top-title-button my-2 ${
          direction === "rtl" ? "text-right" : "text-left"
        }`}
      >
        <PageTitle title={<Translator id="user_Account" />} />
        <div className="top-buttons">
          <div className="show-user-name">
            {data ? (
              <>
                <span>{`${t("userName")} :`}</span>
                <p>{data?.UserName}</p>
              </>
            ) : (
              <CircularProgress size={20} thickness={2} />
            )}
          </div>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                className={`switcher ${direction}`}
                checked={twoFactor}
                onChange={switchChange}
              />
            }
            label={<Translator id={"twoStepLogin"} />}
            className="two-step-login"
          />
        </div>
      </div>
      <TabContext value={tab}>
        <Box>
          <TabList onChange={handleChange} variant="scrollable">
            <Tab
              icon={<Icons.Person />}
              label={t("last_Name")}
              value="last_Name"
            />
            <Tab icon={<Icons.Envelope />} label={t("email")} value="email" />
            <Tab icon={<Icons.Phone />} label={t("phone")} value="phone" />
            <Tab icon={<Icons.Key />} label={t("password")} value="password" />
          </TabList>
        </Box>
        <MuiPaper>
          <TabPanel value="last_Name" className="py-3 px-2 m-0">
            <ProfileInfo data={data} />
          </TabPanel>
          <TabPanel value="email" className="py-3 px-2 m-0">
            <ProfileEmail data={data} />
          </TabPanel>
          <TabPanel value="phone" className="py-3 px-2 m-0">
            <ProfilePhone data={data} />
          </TabPanel>
          <TabPanel value="password" className="py-3 px-2 m-0">
            <ProfilePassword />
          </TabPanel>
        </MuiPaper>
      </TabContext>
    </Fragment>
  );
}
